module.exports = __webpack_public_path__ + "static/media/Alejandra.3f9bff08.jpg";